import React, { useState, useEffect } from 'react';
import { countdownDate } from '../data/mockData';

const CountdownSection = () => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, mins: 0, secs: 0 });

  useEffect(() => {
    const calculateTime = () => {
      const now = new Date();
      const diff = countdownDate - now;

      if (diff <= 0) {
        setTimeLeft({ days: 0, hours: 0, mins: 0, secs: 0 });
        return;
      }

      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        mins: Math.floor((diff / (1000 * 60)) % 60),
        secs: Math.floor((diff / 1000) % 60),
      });
    };

    calculateTime();
    const interval = setInterval(calculateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const timeUnits = [
    { value: timeLeft.days, label: 'Days' },
    { value: timeLeft.hours, label: 'Hours' },
    { value: timeLeft.mins, label: 'Mins' },
    { value: timeLeft.secs, label: 'Secs' },
  ];

  return (
    <section className="relative z-20 -mt-[50px] sm:-mt-[70px] md:-mt-[90px] lg:-mt-[110px]">
      <div className="flex flex-row flex-nowrap justify-center gap-2 sm:gap-4 md:gap-8 lg:gap-12 px-2 sm:px-4 pb-2">
        {timeUnits.map((unit, index) => (
          <div
            key={index}
            className="flex-shrink-0 w-[80px] h-[80px] sm:w-[120px] sm:h-[120px] md:w-[204px] md:h-[204px] lg:w-[244px] lg:h-[244px] rounded-full border border-white/40 flex items-center justify-center animate-countdown-emerge"
            style={{ animationDelay: `${0.6 + index * 0.15}s` }}
          >
            <div className="relative w-[68px] h-[68px] sm:w-[100px] sm:h-[100px] md:w-[180px] md:h-[180px] lg:w-[220px] lg:h-[220px] rounded-full bg-[#7A1E3A] flex flex-col items-center justify-center">
              <div className="absolute inset-[3px] sm:inset-[5px] rounded-full border border-white/30"></div>
              <span className="text-xl sm:text-3xl md:text-5xl lg:text-6xl font-body font-light text-white relative z-10">
                {String(unit.value).padStart(2, '0')}
              </span>
              <span className="text-[10px] sm:text-xs md:text-base font-body text-white/80 mt-0.5 sm:mt-1 relative z-10">
                {unit.label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CountdownSection;
